import { render, staticRenderFns } from "./PriceDescription.vue?vue&type=template&id=3d0ccf91&"
import script from "./PriceDescription.vue?vue&type=script&lang=js&"
export * from "./PriceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports